import BillingNumberCirclesAbstractEditorController from './abstract-editor-controller';

export default class BillingNumberCirclesEditController extends BillingNumberCirclesAbstractEditorController {
    $onInit() {
        super.$onInit();

        this._loadNumberCircle();
    }

    _loadNumberCircle() {
        this._updateNavigation();
        this.api
            .get(`billing/number-circles/${this.stateParams.id}`)
            .then(({data}) => {
                this.model = data.data;
                this.loading = false;
                this._updateNavigation();
            })
    }

    doSave() {
        this.api
            .put(`billing/number-circles/${this.model.id}`, this.model)
            .then(() => {
                this.alert.success(
                    this.translate.instant('general.alerts.change_save_success.title'),
                    this.translate.instant('general.alerts.change_save_success.content')
                )
                this.cancel();
            })
            .catch((res) => {
                this.alert.handle(res);
                this.submitting = false;
            })
    }

    _updateNavigation() {
        this.navHelper.setTranslationsParamsForEntry(
            'settings.billing.number_circles.details',
            {
                name: this.loading ? this.translate.instant('general.verbs.loading_dot') : this.model.title
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/number-circles/controllers/edit-controller.js